import type { DialogProps as DesignSystemDialogProps } from "@octopusdeploy/design-system-components";
import { Dialog as DesignSystemDialog, DialogActions, DialogTitle } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import ErrorContextProvider from "../ErrorContext/ErrorContext";
export interface DialogProps extends DesignSystemDialogProps {
    title?: string;
    actions?: React.ReactNode;
}
// eslint-disable-next-line jsdoc/require-param
/**
 * @deprecated Use workflows instead. See https://docs.octopushq.com/docs/frontend/workflows
 */
function Dialog({ open, dialogWidth, fullScreen, title, actions, children, onExited, keepChildrenMounted }: DialogProps) {
    return (<DesignSystemDialog open={open} dialogWidth={dialogWidth} fullScreen={fullScreen} onExited={onExited} keepChildrenMounted={keepChildrenMounted}>
            <ErrorContextProvider>
                {title && <DialogTitle>{title}</DialogTitle>}
                {children}
                {actions && <DialogActions>{actions}</DialogActions>}
            </ErrorContextProvider>
        </DesignSystemDialog>);
}
export default Dialog;
